<template>
    <header class="page-header">
        <LogoHeader :isLink="true" :noSep="true" :position="left" :path="'/index'" />
        <h1>{{ title }}</h1>
    </header>
</template>

<script>

import LogoHeader from '../shared/LogoHeader';

export default {
	name: 'PageHeader',
    props: ['title'],
	components: {
		LogoHeader,
	},
};

</script>